document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.header');
    const imageBanner = document.querySelector('.image-banner');
    const pictureBanner = document.querySelector('.picture-banner');

    const headerObserver = new IntersectionObserver((entries) => {
        header.classList.toggle('header--brown', !entries[0].isIntersecting);
    });
    if (imageBanner)
        headerObserver.observe(imageBanner);
    if (pictureBanner)
        headerObserver.observe(pictureBanner);
    if (!imageBanner && !pictureBanner) {
        header.classList.add('header--brown');
    }
});